(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('campagnalog-tipo', {
            parent: 'entity',
            url: '/campagnalog-tipo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnalog_tipo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipos.html',
                    controller: 'Campagnalog_tipoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnalog_tipo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('campagnalog-tipo-detail', {
            parent: 'entity',
            url: '/campagnalog-tipo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.campagnalog_tipo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-detail.html',
                    controller: 'Campagnalog_tipoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('campagnalog_tipo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Campagnalog_tipo', function($stateParams, Campagnalog_tipo) {
                    return Campagnalog_tipo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'campagnalog-tipo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('campagnalog-tipo-detail.edit', {
            parent: 'campagnalog-tipo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-dialog.html',
                    controller: 'Campagnalog_tipoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagnalog_tipo', function(Campagnalog_tipo) {
                            return Campagnalog_tipo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagnalog-tipo.new', {
            parent: 'campagnalog-tipo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-dialog.html',
                    controller: 'Campagnalog_tipoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('campagnalog-tipo', null, { reload: 'campagnalog-tipo' });
                }, function() {
                    $state.go('campagnalog-tipo');
                });
            }]
        })
        .state('campagnalog-tipo.edit', {
            parent: 'campagnalog-tipo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-dialog.html',
                    controller: 'Campagnalog_tipoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Campagnalog_tipo', function(Campagnalog_tipo) {
                            return Campagnalog_tipo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagnalog-tipo', null, { reload: 'campagnalog-tipo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('campagnalog-tipo.delete', {
            parent: 'campagnalog-tipo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/campagnalog-tipo/campagnalog-tipo-delete-dialog.html',
                    controller: 'Campagnalog_tipoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Campagnalog_tipo', function(Campagnalog_tipo) {
                            return Campagnalog_tipo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('campagnalog-tipo', null, { reload: 'campagnalog-tipo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
